import React, { useEffect, useState } from 'react';
import { bottomBoxComponentUpdate, showError } from '../../../../../Helper';
import { LeadXchangeGetAllSharedLeads } from '../../../../../Services/LeadXChangeServices/LeadXChangeServices';
import LeadXChangeLeadFilter from './Components/LeadXChangeLeadFilter';
import { PaginationComponent, Spinner } from '../../../../../Components';
import LeadXChangeLeadActions from './Components/LeadXChangeLeadActions';
import LeadXChangeCard from './Components/LeadXChangeCard';
import { useLeadXchangeData } from './Context/LeadXchangeData';
import { useKeyGenerator } from '../../../../../Hooks/keyGenerator';
import { useDebouncedAction } from '../../../../../Hooks/DebouncedAction';

function LeadxchangeLeadsView() {
  const [key, refresh] = useKeyGenerator();
  const [loading, setLoading] = useState(false);
  const { setActionableItems } = useLeadXchangeData();

  const [sharedLeads, setSharedLeads] = useState({
    result: [],
    totalCount: 0,
  });
  const defaultFilter = {
    pageSize: 25,
    pageIndex: 1,
    language: null,
    nationality: null,
    contactName: null,
    community: null,
    city: null,
    district: null,
    crmLeadId: null,
    sharedDateTo: null,
    sharedDateFrom: null,
    status: null,
    leadClass: {
      id: null,
      name: null,
    },
    leadExchangePoolSource: {
      sourceId: null,
      sourceName: null,
    },
    orderBy: 2,
    filterBy: 'SharedDate',
  };
  const [filter, setFilter] = useState(defaultFilter);

  const onClearedFiltersClick = () => {
    setFilter({
      language: null,
      nationality: null,
      contactName: null,
      community: null,
      city: null,
      district: null,
      crmLeadId: null,
      leadExchangePoolSource: {
        sourceId: null,
        sourceName: null,
      },
      pageIndex: 1,
      pageSize: 25,
    });

    setActionableItems({
      selectedIds: [],
      action: null,
    });
    refresh();
  };

  const getAllSharedLeads = useDebouncedAction(
    async () => {
      setLoading(true);
      try {
        const result = await LeadXchangeGetAllSharedLeads(filter);
        setSharedLeads(result);
      } catch {
        showError('something went wrong');
      } finally {
        setLoading(false);
      }
    },
    {
      delay: 100,
    }
  );

  useEffect(() => {
    getAllSharedLeads();
  }, [filter]);

  const reload = () => {
    setFilter(defaultFilter);
    getAllSharedLeads();
  };

  useEffect(() => {
    bottomBoxComponentUpdate(
      <PaginationComponent
        pageIndex={filter.pageIndex - 1}
        pageSize={filter.pageSize}
        totalCount={sharedLeads.totalCount}
        onPageIndexChanged={(pageIndex) => {
          setFilter((prev) => ({ ...prev, pageIndex: pageIndex + 1 }));
        }}
        onPageSizeChanged={(pageSize) => {
          setFilter((prev) => ({ ...prev, pageSize }));
        }}
      />
    );
    return () => {
      bottomBoxComponentUpdate(null);
    };
  });
  return (
    <div className='leadxchange-content'>
      <Spinner isActive={loading} />
      <LeadXChangeLeadActions
        setFilter={setFilter}
        filter={filter}
        onClearedFiltersClick={onClearedFiltersClick}
        reload={reload}
        defaultFilter={defaultFilter}
        setLoading={setLoading}
      />
      <LeadXChangeLeadFilter
        setFilter={setFilter}
        filter={filter}
        key={key}
      />

      {sharedLeads.result.map((lead) => (
        <LeadXChangeCard
          leadData={lead}
          setFilter={setFilter}
          sharedLeads={sharedLeads}
          reload={reload}
          setLoading={setLoading}
        />
      ))}
    </div>
  );
}

export default LeadxchangeLeadsView;
